import React, { useEffect } from 'react';
import { useFetch } from '../../../utils/hooks/useFetch';
import { ContactUsApi } from '../../../api/base/ContactUs';
import { useParams } from 'react-router';
import { Button } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        gap: "10px",
        margin: "15px 0"
    },
    expLink:{
        textDecoration: "none"
    }
}));

export const ExpertiseBadge: React.FC = () => {
    const params:any = useParams();
    const [{ response, isLoading }, doFetch] = useFetch(
        ContactUsApi.getExpertise,
    );
    
    useEffect(() => {
        doFetch(params.id);
    }, [doFetch]);

    console.log(response);
    const classes = useStyles(); 

    return (
      <div className={classes.root}>
          {response?.data?.map((exp:any)=>(
              <Button
                key={exp.id}
                variant="outlined"
                size="small" 
                color="primary"
            >
                <Link to={`/allposts?id=${exp.id}`} className={classes.expLink}>
                {exp.name}
                </Link>
            </Button>
          ))}
      </div>
    )
}